module.exports = __webpack_public_path__ + "img/gameTronos8.7322c56a.jpg";